import { composeClasses } from '@/utils/compose-classes'

export interface TabProps {
  /**
   * For indicate the text of the tab
   * */
  title?: string
  /**
   * className of the tab container
   * */
  className?: string
  /**
   * Icon placed at right of the title or children
   * */
  iconRight?: React.ReactNode
  /**
   * Icon placed at left of the title or children
   * */
  iconLeft?: React.ReactNode
  /**
   * Flag to indicate the tab is disabled
   * */
  isDisabled?: boolean
  /**
   * React Node to display something inside the tab
   * */
  children?: React.ReactNode
  /**
   * Flag to indicate the tab is active
   * */
  active?: boolean
  /**
   * className when the tab is active
   * */
  activeBgColorClass?: string
  /**
   * ClassName launched when the tab is hover and active
   * */
  onHoverClass?: string
  /**
   * ClassnName launched when the tab is active and actived
   * */
  onActiveClass?: string
  /**
   * Function launched when the tab is clicked
   * */
  onClick: () => void
}

export const Tab = ({
  active,
  activeBgColorClass = 'bg-primary',
  className,
  iconLeft,
  iconRight,
  isDisabled = false,
  onActiveClass = 'active:bg-button-secondary',
  onHoverClass = 'hover:bg-button-disabled',
  title,
  onClick
}: TabProps) => {
  const getTextColor = () => {
    if (isDisabled) {
      return 'text-terciary'
    }
    return active ? 'text-primary' : 'text-secondary'
  }
  return (
    <button
      disabled={isDisabled}
      data-testid="tab"
      name={title}
      onClick={onClick}
      className={composeClasses(
        'h-full w-auto min-w-[5.5rem] p-4 flex gap-2 items-center transition-all duration-300 group relative text-sm justify-center whitespace-nowrap',
        active ? `font-medium` : 'font-normal',
        getTextColor(),
        isDisabled
          ? ''
          : `${onHoverClass} ${onActiveClass} active:scale-95 cursor-pointer`,
        className
      )}
    >
      {iconLeft}
      <p>{title}</p>
      {iconRight}
      {active && (
        <div
          className={composeClasses(
            'scale-up-horizontal-left absolute w-full h-1  bottom-0 left-0',
            activeBgColorClass
          )}
        ></div>
      )}
    </button>
  )
}
export default Tab
